document.addEventListener('keydown',function(event){
  const thumb=event.target.closest('.qe-product [data-thumbs] [data-slide-media-id]');
  if(!thumb||!['Enter',' '].includes(event.key))return;
  event.preventDefault();
  const gallery=thumb.closest('gallery-section');
  const swiper=gallery?.gallerySwiper||gallery?.querySelector('[data-gallery]')?.swiper;
  if(!swiper)return;
  const id=thumb.dataset.slideMediaId;
  const index=Array.from(swiper.slides).findIndex(slide=>slide.dataset.mediaId===id||slide.querySelector('[data-media-id="'+id+'"]'));
  if(index>=0)swiper.slideTo(index,window.matchMedia('(prefers-reduced-motion: reduce)').matches?0:150);
});

(function(){
  let observer;
  function measureSticky(){
    if(observer)observer.disconnect();
    const bars=Array.from(document.querySelectorAll('sticky-buy-button.wt-product__sticky-buy'));
    const update=()=>{
      const height=Math.max(0,...bars.map(bar=>bar.getBoundingClientRect().height));
      document.documentElement.style.setProperty('--quantum-sticky-buy-height',Math.ceil(height||80)+'px');
    };
    update();
    if('ResizeObserver' in window){
      observer=new ResizeObserver(update);
      bars.forEach(bar=>observer.observe(bar));
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',measureSticky,{once:true});
  else measureSticky();
  document.addEventListener('shopify:section:load',measureSticky);
})();


(function(){
  function connectGallery(gallery){
    if(!gallery.closest('.qe-product'))return;
    const swiper=gallery.gallerySwiper;
    const controls=gallery.querySelector('[data-qe-gallery-controls]');
    if(!swiper||!controls||controls._qeSwiper===swiper)return;
    controls._qeSwiper=swiper;
    swiper.allowTouchMove=true;
    swiper.params.allowTouchMove=true;
    swiper.params.simulateTouch=true;
    swiper.params.autoHeight=false;
    const dots=controls.querySelector('.qe-gallery-dots');
    const previous=controls.querySelector('.qe-gallery-prev');
    const next=controls.querySelector('.qe-gallery-next');
    let count=-1;
    const update=()=>{
      const length=swiper.slides.length;
      controls.hidden=length<2;
      if(count!==length){
        count=length;dots.replaceChildren();
        for(let index=0;index<length;index++){
          const button=document.createElement('button');
          button.type='button';button.dataset.qeSlide=String(index);
          button.setAttribute('aria-label',controls.dataset.imageLabel.replace('__INDEX__',String(index+1)));
          dots.append(button);
        }
      }
      dots.querySelectorAll('button').forEach((button,index)=>button.setAttribute('aria-current',String(index===swiper.activeIndex)));
      previous.disabled=swiper.activeIndex===0;
      next.disabled=swiper.activeIndex>=length-1;
    };
    if(!controls.dataset.qeBound){
      controls.dataset.qeBound='true';
      controls.addEventListener('click',event=>{
        const button=event.target.closest('button');
        if(!button)return;
        const active=gallery.gallerySwiper;
        if(!active)return;
        const speed=window.matchMedia('(prefers-reduced-motion: reduce)').matches?0:250;
        if(button.dataset.qeSlide!==undefined)active.slideTo(Number(button.dataset.qeSlide),speed);
        else if(button===previous)active.slidePrev(speed);
        else if(button===next)active.slideNext(speed);
      });
      const viewport=gallery.querySelector('[data-gallery]');
      viewport.tabIndex=0;
      viewport.addEventListener('keydown',event=>{
        if(event.target!==viewport||!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
        const active=gallery.gallerySwiper;if(!active)return;
        event.preventDefault();
        const last=active.slides.length-1;
        const index=event.key==='Home'?0:event.key==='End'?last:Math.max(0,Math.min(last,active.activeIndex+(event.key==='ArrowRight'?1:-1)));
        active.slideTo(index,window.matchMedia('(prefers-reduced-motion: reduce)').matches?0:250);
      });
    }
    swiper.on('slideChange',update);
    swiper.on('slidesLengthChange',update);
    swiper.on('update',update);
    update();
  }
  document.addEventListener('quantum:gallery-ready',event=>connectGallery(event.target));
  customElements.whenDefined('gallery-section').then(()=>document.querySelectorAll('.qe-product gallery-section').forEach(connectGallery));
})();
